$(() => {
  const set_wfm_implementation_fee = (ss, ta) => {
    let cost = 198000;

    if (ss === false || ta === false) {
      cost = cost * (2/3)
    }

    if ($('#wfm-implementation-fee-overridden').val() === '0') {
      $('#wfm-implementation-fee').val(accounting.formatMoney(cost, '', 0))
    }
  };

  const enterprise_total_cost = (employee_count) => {
    let per_employee = 0;
    let base = 0;
    let employees_included = 0;

    if (employee_count < 1000) {
      base = 10000;
      employees_included = 0;
      per_employee = 0;
    } else if (employee_count < 2500) {
      base = 10000;
      employees_included = 1000;
      per_employee = 10;
    } else if (employee_count < 5000) {
      base = 25000;
      employees_included = 2500;
      per_employee = 7;
    } else if (employee_count < 15000) {
      base = 42500;
      employees_included = 5000;
      per_employee = 5.5;
    } else {
      base = 97500;
      employees_included = 15000;
      per_employee = 4.5;
    }

    additional_cost = (employee_count - employees_included) * per_employee;

    return (base + additional_cost) * 12;
  };

  const ss_total_cost = (employee_count) => {
    let per_employee = 0;
    let base = 0;
    let employees_included = 0;

    if (employee_count < 1000) {
      base = 6000;
      employees_included = 0;
      per_employee = 0;
    } else if (employee_count < 2500) {
      base = 6000;
      employees_included = 1000;
      per_employee = 6;
    } else if (employee_count < 5000) {
      base = 15000;
      employees_included = 2500;
      per_employee = 4;
    } else if (employee_count < 15000) {
      base = 25000;
      employees_included = 5000;
      per_employee = 3.5;
    } else {
      base = 60000;
      employees_included = 15000;
      per_employee = 3;
    }

    additional_cost = (employee_count - employees_included) * per_employee;

    return (base + additional_cost) * 12;
  };

  const ta_total_cost = (employee_count) => {
    let per_employee = 0;
    let base = 0;
    let employees_included = 0;

    if (employee_count < 1000) {
      base = 5000;
      employees_included = 0;
      per_employee = 0;
    } else if (employee_count < 2500) {
      base = 5000;
      employees_included = 1000;
      per_employee = 5;
    } else if (employee_count < 5000) {
      base = 12500;
      employees_included = 2500;
      per_employee = 3;
    } else if (employee_count < 15000) {
      base = 20000;
      employees_included = 5000;
      per_employee = 2.5;
    } else {
      base = 45000;
      employees_included = 15000;
      per_employee = 2;
    }

    additional_cost = (employee_count - employees_included) * per_employee;

    return (base + additional_cost) * 12;
  };

  const set_wfm_license_fee = (ss, ta) => {
    if ($('#wfm-license-fee-overridden').val() === '1') { return; }

    const no_of_employees = parseInt($('#number-of-employees').val().replace(',' , ''));
    let cost = 0;

    if (ss === false && ta === true) {
      cost = ta_total_cost(no_of_employees);
      $('#wfm-license-fee').val(accounting.formatMoney(cost, '', 0))
    } else if (ss === true && ta === false) {
      cost = ss_total_cost(no_of_employees);
      $('#wfm-license-fee').val(accounting.formatMoney(cost, '', 0))
    } else if (ss === true && ta === true) {
      cost = enterprise_total_cost(no_of_employees);
      $('#wfm-license-fee').val(accounting.formatMoney(cost, '', 0))
    }

    $('#wfm-license-fee').val(accounting.formatMoney(cost, '', 0))
  };

  const set_cc_license_fee = (cc) => {
    if ($('#cc-license-fee-overridden').val() === '1') { return; }

    if (cc === false) {
      $('#cc-license-fee').val(accounting.formatMoney(0, '', 0));
      return;
    }

    let fee = 0;

    const no_of_beds = parseInt($('#number-of-beds').val().replace(',', ''));
    if (no_of_beds < 49) {
      fee = 1080;
    } else if (no_of_beds < 99) {
      fee = 981.82;
    } else if (no_of_beds < 499) {
      fee = 932.73;
    } else if (no_of_beds < 999) {
      fee = 883.64;
    } else if (no_of_beds < 1499) {
      fee = 834.55;
    } else if (no_of_beds < 1999) {
      fee = 785.45;
    } else if (no_of_beds < 2999) {
      fee = 736.36;
    } else if (no_of_beds < 3999) {
      fee = 687.27;
    } else if (no_of_beds < 4999) {
      fee = 589.09;
    } else {
      fee = 490.91;
    }

    const cost = fee * no_of_beds;
    $('#cc-license-fee').val(accounting.formatMoney(cost, '', 0));
  };

  const set_cc_implementation_fee = (cc) => {
    if ($('#cc-implementation-fee-overridden').val() === '1') { return; }

    if (cc === false) {
      $('#cc-implementation-fee').val(accounting.formatMoney(0, '', 0));
      return;
    }

    const no_of_beds = parseInt($('#number-of-beds').val().replace(',', ''));
    let cost = 392750;

    if (no_of_beds < 51) {
      cost = 11500;
    } else if (no_of_beds < 101) {
      cost = 19000;
    } else if (no_of_beds < 151) {
      cost = 26500;
    } else if (no_of_beds < 201) {
      cost = 34000;
    } else if (no_of_beds < 251) {
      cost = 41500;
    } else if (no_of_beds < 351) {
      cost = 91500;
    } else if (no_of_beds < 501) {
      cost = 120750;
    } else if (no_of_beds < 1001) {
      cost = 179750;
    } else if (no_of_beds < 1501) {
      cost = 251500;
    }

    $('#cc-implementation-fee').val(accounting.formatMoney(cost, '', 0));
  };

  const run = () => {
    const ss = $('#product-ss-checkbox').is(':checked');
    const ta = $('#product-ta-checkbox').is(':checked');
    const cc = $('#product-cc-checkbox').is(':checked');

    set_wfm_implementation_fee(ss, ta);
    set_wfm_license_fee(ss, ta);
    set_cc_license_fee(cc);
    set_cc_implementation_fee(cc);
  };

  $('#number-of-employees, #number-of-beds').blur(() => {
    run();
  });

  $('#product-ss-checkbox, #product-ta-checkbox, #product-cc-checkbox').change(() => {
    run();
  });

  $('#wfm-implementation-fee').blur(() => {
    $('#wfm-implementation-fee-overridden').val('1');
  });

  $('#wfm-license-fee').blur(() => {
    $('#wfm-license-fee-overridden').val('1');
  });

  $('#cc-license-fee').blur(() => {
    $('#cc-license-fee-overridden').val('1');
  });

  $('#cc-implementation-fee').blur(() => {
    $('#cc-implementation-fee-overridden').val('1');
  });
});
